import React, {useState} from 'react'
import {aboveHeaderStyle} from './index.style'
import {
    Box,
    List,
    ListItem,
    Text,
    Link,
    Button,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {Link as RouteLink} from 'react-router-dom'
import {AuthHelpers, useAuthHelper, useCustomerType} from '@salesforce/commerce-sdk-react'
import {ChevronDownIcon} from '@salesforce/retail-react-app/app/components/icons'
import {useIntl} from 'react-intl'
import {pxToRem} from '../../../../utills/pxToRem'
import {getControllerUrl} from '../../../../utills/controllerUrlGenerator'
import sites from '../../../../../../config/sites'

import {useOutsideClick} from '@chakra-ui/react'
import HeaderPromotionBanner from '../header-promotion-banner'
import withRegistration from '../../../../components/with-registration'
import {IconButton} from '@salesforce/retail-react-app/app/components/shared/ui'
import {AuthModal, useAuthModal} from '../../../../hooks/use-auth-modal'
const AboveHeader = () => {
    const intl = useIntl()
    const {isRegistered} = useCustomerType()
    const {data: customer} = useCurrentCustomer()
    const logout = useAuthHelper(AuthHelpers?.Logout)
    const [active, setActive] = useState(false)
    const authModal = useAuthModal()
    const styles = useMultiStyleConfig()

    const IconButtonWithRegistration = withRegistration(IconButton)

    const ref = React.useRef()
    useOutsideClick({
        ref: ref,
        handler: (event) => {
            if ((event.type === 'mousedown' || event.type === 'mouseup') && event.button === 2) {
                return
            }
            setActive(false)
        }
    })

    const handleToggleMyAccount = () => {
        setActive(!active)
    }

    const onSignoutClick = async () => {
        await logout.mutateAsync()
        window.location.href = '/login'
    }

    const renderCustomerLinks = () => (
        <>
            <Link {...styles.linkItem} className="links" href="/account/">
                <Text className="text username" {...styles.text} sx={{paddingBottom: pxToRem(10)}}>
                    {`${customer?.firstName || ''} ${customer?.lastName || ''}`.trim()}
                </Text>
            </Link>
            <Link
                {...styles.linkItem}
                className="links"
                href={getControllerUrl(
                    sites[0].id,
                    sites[0].l10n.defaultLocale,
                    'Account-Settings'
                )}
                title={intl.formatMessage({
                    id: 'header.link.go_to_account_settings',
                    defaultMessage: 'Go to Account Settings'
                })}
            >
                <Text className="text" {...styles.text}>
                    {intl.formatMessage({
                        id: 'header.link.account_settings',
                        defaultMessage: 'Account Settings'
                    })}
                </Text>
            </Link>
            <Link
                className="links"
                href="/orders/"
                title={intl.formatMessage({
                    id: 'header.link.go_to_order_history',
                    defaultMessage: 'Go to Order History'
                })}
            >
                <Text className="text" {...styles.text}>
                    {intl.formatMessage({
                        id: 'header.link.order_history',
                        defaultMessage: 'Order History'
                    })}
                </Text>
            </Link>
            <Link
                className="links"
                href="/wishlistpage/"
                title={intl.formatMessage({
                    id: 'header.link.go_to_wishlist',
                    defaultMessage: 'Go to Wishlist'
                })}
            >
                <Text className="text" {...styles.text}>
                    {intl.formatMessage({id: 'header.link.wishlist', defaultMessage: 'Wish List'})}
                </Text>
            </Link>
            <Button
                className="logout-btn"
                onClick={onSignoutClick}
                title={intl.formatMessage({
                    id: 'header.link.go_to_logout',
                    defaultMessage: 'Go to Logout'
                })}
            >
                {intl.formatMessage({id: 'header.link.logout', defaultMessage: 'LOGOUT'})}
            </Button>
        </>
    )

    const renderGuestLinks = () => (
        <>
            <Link
                {...styles.linkItem}
                className="links"
                // href="/account/"
                onClick={authModal.onOpen}
                title={intl.formatMessage({
                    id: 'header.link.go_to_login',
                    defaultMessage: 'Go to Login'
                })}
            >
                <Text className="text" {...styles.text}>
                    {intl.formatMessage({id: 'header.link.login', defaultMessage: 'Login'})}
                </Text>
            </Link>
            <Link
                className="links"
                // href="/register/"
                onClick={authModal.onOpen}
                title={intl.formatMessage({
                    id: 'header.link.go_to_register',
                    defaultMessage: 'Go to Register'
                })}
            >
                <Text className="text" {...styles.text}>
                    {intl.formatMessage({id: 'header.link.register', defaultMessage: 'Register'})}
                </Text>
            </Link>
        </>
    )

    return (
        <Box sx={aboveHeaderStyle}>
            <Box className="above-header-wrapper">
                <Box id="navigation" class="clearfix">
                    <Box className="top-header-bar clearfix has-promo-banner">
                        <Box className="top-header-bar-inner">
                            <HeaderPromotionBanner />
                            <List>
                                <ListItem>
                                    <Link to="/help/" as={RouteLink}>
                                        <Text className="top-header-item">
                                            {intl.formatMessage({
                                                id: 'header.link.customer_services',
                                                defaultMessage: 'CUSTOMER SERVICE'
                                            })}
                                        </Text>
                                    </Link>
                                </ListItem>
                                <ListItem>
                                    <Link href="/orders/#ord-track">
                                        <Text className="top-header-item">
                                            {intl.formatMessage({
                                                id: 'header.link.track_my_orders',
                                                defaultMessage: 'Track My Order'
                                            })}
                                        </Text>
                                    </Link>
                                </ListItem>

                                <ListItem className="user-info">
                                    <Link
                                        ref={ref}
                                        className="user-account"
                                        onClick={handleToggleMyAccount}
                                        title={
                                            isRegistered && customer
                                                ? `User: ${customer?.firstName || ''} ${
                                                      customer?.lastName || ''
                                                  }`.trim()
                                                : intl.formatMessage({
                                                      id: 'header.link.default_user',
                                                      defaultMessage: 'User: Login / Register'
                                                  })
                                        }
                                    >
                                        <Text className="top-header-item">
                                            {intl.formatMessage({
                                                id: 'header.link.my_account',
                                                defaultMessage: 'My Account'
                                            })}
                                            <ChevronDownIcon padding={pxToRem(2)} />
                                        </Text>
                                    </Link>
                                    <Box className={`user-panel ${active ? 'hide' : ''}`}>
                                        <Box className="user-links">
                                            {isRegistered
                                                ? renderCustomerLinks()
                                                : renderGuestLinks()}
                                        </Box>
                                    </Box>
                                </ListItem>

                                <AuthModal {...authModal} />
                            </List>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}
export default AboveHeader
